export enum PayoutAccountType {
  UNDEFINED = 0,
  STRIPE = 1,
  PAYPAL = 2,
}
  